<template>
  <div>
    <form v-if="task" @submit.prevent="$emit('submit')">
      <div class="p-4 space-y-12">
        <Attributes
          :editable="canEdit && isIdle"
          :title.sync="titleInput"
          :content.sync="contentInput"
        />
      </div>
    </form>
    <div class="p-4 space-y-12">
      <RelatedAttachments
        v-if="task.uuid"
        :task-id="task.uuid"
        :editable="canEdit && isIdle"
        :attachments.sync="mediaInput"
      />
    </div>
  </div>
</template>

<script>
import Attributes from './task/Attributes.vue';
import RelatedAttachments from './task/RelatedAttachments.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  name: 'Task',

  components: {
    Attributes,
    RelatedAttachments,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
    memberOptions: {
      type: Array,
      default: () => [],
    },
    submitStatus: {
      type: String,
      default: STATUS_IDLE,
    },
    canEdit: Boolean,
  },

  data() {
    return {
      statusOptions: [
        { value: 'draft', label: 'Draft' },
        { value: 'pending', label: 'Pending' },
        { value: 'pending corrections', label: 'Pending corrections' },
        { value: 'in progress', label: 'In progress' },
        { value: 'in review', label: 'In review' },
        { value: 'completed', label: 'Completed' },
      ],
    };
  },

  computed: {
    isIdle() {
      return this.submitStatus === STATUS_IDLE;
    },
    isPending() {
      return this.submitStatus === STATUS_PENDING;
    },
    isResolved() {
      return this.submitStatus === STATUS_RESOLVED;
    },
    isRejected() {
      return this.submitStatus === STATUS_REJECTED;
    },
    titleInput: {
      get() {
        return this.task.title;
      },
      set(value) {
        return this.$emit('update:title', value);
      },
    },
    contentInput: {
      get() {
        return this.task.content;
      },
      set(value) {
        this.$emit('update:content', value);
      },
    },
    mediaInput: {
      get() {
        return this.task.media;
      },
      set(value) {
        this.$emit('update:media', value);
      },
    },
  },
};
</script>
